import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Users, UserX } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
export const STOPPED_CHANGED_EVENT = 'stopped-customers:changed';

const TabButton = ({ active, onClick, icon: Icon, label, shortLabel, badge, testId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className={`inline-flex items-center gap-2 px-3 sm:px-4 h-9 whitespace-nowrap rounded-lg text-xs sm:text-sm font-semibold transition-colors duration-200 ${
      active
        ? 'bg-white dark:bg-slate-800 text-indigo-700 dark:text-indigo-300 shadow-sm ring-1 ring-slate-200 dark:ring-slate-700'
        : 'text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-200'
    }`}
  >
    <Icon className="w-4 h-4" />
    <span className="sm:hidden">{shortLabel}</span>
    <span className="hidden sm:inline">{label}</span>
    {badge > 0 && (
      <span
        data-testid={`${testId}-count`}
        className="min-w-[1.25rem] px-1.5 h-5 inline-flex items-center justify-center rounded-full bg-rose-100 text-rose-700 dark:bg-rose-900/50 dark:text-rose-300 text-[10px] font-bold tabular-nums"
      >
        {badge > 9999 ? '9999+' : badge}
      </span>
    )}
  </button>
);

export default function CustomerListTabs({ active, onChange, connectionType }) {
  const [count, setCount] = useState(0);

  const load = useCallback(() => {
    const p = new URLSearchParams({ months: '2', limit: '1', connection_type: connectionType || '' });
    axios
      .get(`${API_URL}/api/v2/stopped-customers?${p}`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then((r) => setCount(r.data?.total || 0))
      .catch(() => setCount(0));
  }, [connectionType]);

  useEffect(() => { load(); }, [load, active]);
  useEffect(() => {
    window.addEventListener(STOPPED_CHANGED_EVENT, load);
    return () => window.removeEventListener(STOPPED_CHANGED_EVENT, load);
  }, [load]);

  return (
    <div className="inline-flex items-center gap-1 p-1 rounded-xl bg-slate-200/60 dark:bg-slate-800/60" data-testid="customer-list-tabs">
      <TabButton active={active === 'all'} onClick={() => onChange('all')} icon={Users} label="Daftar Pelanggan" shortLabel="Semua" testId="tab-customers-all" />
      <TabButton active={active === 'stopped'} onClick={() => onChange('stopped')} icon={UserX} label="Pelanggan Berhenti" shortLabel="Berhenti" badge={count} testId="tab-customers-stopped" />
    </div>
  );
}
